'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense } from 'react';
import { ThemeProvider } from 'next-themes';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ChangeProvider, TestCaseProvider } from '@/contexts';
import { WorkspaceProvider } from '@/contexts/workspace-context';
import { CrucibleToaster } from '@/components/ui/crucible-toaster';
interface ProvidersProps {
  children: React.ReactNode;
}

/**
 * Application providers wrapper.
 *
 * Provides global context:
 * - ChangeContext for tracking XML and canvas changes
 * - Sonner toasts via CrucibleToaster (follows site ThemeToggle)
 *
 * Usage in layout.tsx:
 *   import { Providers } from './providers'
 *   <Providers>{children}</Providers>
 */
export function Providers(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CrucibleToaster />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}><TooltipProvider><Suspense><ChangeProvider><TestCaseProvider><WorkspaceProvider>{children}{t1}</WorkspaceProvider></TestCaseProvider></ChangeProvider></Suspense></TooltipProvider></ThemeProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export default Providers;